





























































































import {
  Vue,
  Component,
  Prop,
  Emit,
  Ref,
  Watch,
  Inject,
  InjectReactive
} from "vue-property-decorator";
import { AudioVideoFacade, VideoTileState, Logger } from "amazon-chime-sdk-js";
import { JsonConsoleLogger } from "@/services/logging/consoleLogger";
import { LocalUserState } from "@/interfaces/meeting/roster";
import { AudioVideoKey } from "@/services/meeting/audioVideoObserver";

@Component({})
export default class VideoTile extends Vue {
  @Prop({ required: true }) localUserState!: LocalUserState;
  @Prop({ type: Boolean, default: false }) isLocal!: boolean;
  @Prop({ required: false }) screenShare!: boolean;
  @Prop({ required: false, type: Boolean, default: false })
  volumeIndicator!: boolean;
  @Ref() video!: HTMLVideoElement;
  @InjectReactive(AudioVideoKey) audioVideo!: AudioVideoFacade;
  @Inject() readonly logger!: JsonConsoleLogger;

  get containerClasses() {
    const classes: Record<string, boolean> = { container: true, "pa-0": true };
    if (!this.cameraOn && !this.screenShare) {
      classes["without-video"] = true;
    }
    if (this.muted) {
      classes["muted"] = true;
    }
    return classes;
  }

  get nameplate() {
    let name = this.userName;
    if (this.screenShare) {
      name = `${name}'s screen`;
    }
    return name;
  }

  get tileId() {
    if (!this.screenShare) {
      return this.localUserState.tileId;
    }
    return this.localUserState.contentTileId;
  }

  get rosterId() {
    return this.localUserState.rosterId;
  }

  get userName() {
    if (this.isLocal && !this.localUserState?.tileId) {
      return "";
    }
    return (
      this.localUserState?.name || (this.isLocal ? "..." : "<Name not set>")
    );
  }

  get muted() {
    return this.localUserState.muted;
  }

  get volume() {
    return this.localUserState.volume || 0;
  }

  get cameraOn() {
    // Turns out tile gets removed when local recording is off
    if (this.isLocal) {
      return this.localUserState.cameraOn;
    }
    return Boolean(this.localUserState.tileId);
  }

  async mounted() {
    this.logger.debug("[TILES][VIDEOTILE] New video tile created");
    if (this.tileId) {
      this.logger.debug(`Tile in new video tile has id: ${this.tileId}`);
      await this.$nextTick();
      this.audioVideo.bindVideoElement(this.tileId, this.video);
    } else {
      this.logger.debug(
        `[TILES][VIDEOTILE] Tile within new video tile is either null or has no id`,
        this.localUserState
      );
    }
  }

  @Watch("tileId")
  async onTileIdChange(newTileId: number, oldTileId: number) {
    this.logger.debug(
      `[TILES][VIDEOTILE] Tile id has changed ${oldTileId} to ${newTileId}`
    );
    if (oldTileId) {
      this.logger.debug("[TILES][VIDEOTILE] Unbinding old tile", oldTileId);
      this.audioVideo.unbindVideoElement(oldTileId);
    }
    if (newTileId) {
      this.logger.debug(
        "[TILES][VIDEOTILE] Binding new tile",
        newTileId,
        this.video
      );
      await this.$nextTick();
      this.audioVideo.bindVideoElement(newTileId, this.video);
    }
  }

  destroyed() {
    this.logger.debug(
      `[TILES][VIDEOTILE] Video tile component is being destroyed ${this.tileId}`,
      this.localUserState
    );
    if (this.tileId) {
      this.logger.debug(
        `[TILES][VIDEOTILE] Unbinding tile ${this.tileId} on destroy`,
        this.localUserState
      );
      this.audioVideo.unbindVideoElement(this.tileId);
    }
  }
}
